// extracted by mini-css-extract-plugin
export default {"ctaArea":"CTA_ctaArea__2t0Dk","ctaAreaHeading":"CTA_ctaAreaHeading__b3o6p","btn":"CTA_btn__5Sc4b"};